<template>
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\loginManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào biểu tượng Đăng nhập ở thanh menu chính của phần trên màn hình, thì màn hình dùng để nhập thông tin đăng nhập sẽ được hiển thị.</p>
                    <p>② Nhập thông tin vào ô Tài khoản và Mật khẩu ở màn hình đó</p>
                    <p>③ Nhấn nút [Đăng nhập], thì xử lý đăng nhập sẽ được thực hiện</p>
                    <p>※ Nếu đánh dấu vào ô Lưu trạng thái đăng nhập, thì vào lần đăng nhập tiếp theo, trạng thái tài khoản và mật khẩu đã lưu sẽ được cập nhật lại khi nhấn vào tiêu đề Tài khoản trên đầu màn hình popup.</p>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {},
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/en/login_manual.vue